// extracted by mini-css-extract-plugin
module.exports = {"title":"trivias_title__2Vq4G"};